import { BRAND, NETCOM_LOCKUP } from '../config/brand.js';
import { SecurityBadge } from './SecurityHighlights.jsx';

export default function Footer() {
  return (
    <footer className="border-t border-[var(--color-line-1)] bg-white px-6 py-4 safe-bottom">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-[var(--color-ink-4)]">
        <div className="flex items-center gap-3 flex-wrap">
          <span><span className="font-medium text-[var(--color-ink-2)]">{BRAND.company}</span>
            <span className="text-[var(--color-ink-5)] mx-2">·</span>
            <span>{NETCOM_LOCKUP}</span></span>
          <SecurityBadge />
        </div>
        <div className="flex items-center gap-4">
          <a href={BRAND.mainSiteUrl} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--color-brand-600)]">{BRAND.mainSiteUrl.replace('https://', '')}</a>
          <a href={`mailto:${BRAND.supportEmail}`} className="hover:text-[var(--color-brand-600)]">{BRAND.supportEmail}</a>
          <span>© {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>
  );
}
